import React from 'react';
import { VISA, MASTERCARD, AMEX } from '../../constants/cardTypes';
import { visa, mastercard, amex } from '../../svg';

/**
 * Returns the icon corresponding to the provided credit card type, or undefined if
 * no match is found.
 *
 * @param type - The card type
 */
export default function cardTypeIcon(
  type: string,
): React.ReactElement | undefined {
  switch (type) {
    case VISA:
      return <img src={visa} alt="visa" />;
    case MASTERCARD:
      return <img src={mastercard} alt="mastercard" />;
    case AMEX:
      return <img src={amex} alt="amex" />;
    default:
      return undefined;
  }
}
